<template>
  <div class="row flex-lg-nowrap">
    <div
      :class="
        'container-widget order-lg-0 order-1 ' + (isFullScreen && windowWidth > 991 ? 'full-screen' : 'col-lg-10')
      "
    >
      <FilterBlockComponent
        ref="filters"
        :models="filterModels"
        :loading="loading"
        :title="searchTitle"
        :key="filterModels"
        :open="isFiltered"
        @submit="search"
        @reset="resetSearch"
      />
      <div class="widget">
        <div class="widget-heading -list position-relative">
          <h1 class="textStyle">
            {{
              $tc("global.list.title", 1, {
                name: this.$tc("studea_manager.registration.title", 2).toLowerCase(),
              })
            }}
            {{
              isFiltered
                ? "(" +
                  (maxResult ? maxResult : Object.keys(datas).length) +
                  " résultat" +
                  ((maxResult ? maxResult : Object.keys(datas).length) > 1 ? "s" : "") +
                  " filtré" +
                  ((maxResult ? maxResult : Object.keys(datas).length) ? "s" : "") +
                  ")"
                : ""
            }}
          </h1>
        </div>
        <div class="widget-content">
          <SortTableComponent
            :actions="actions"
            :apiFilters="true"
            :columns="columns"
            :datas="datas"
            :idKey="columns ? columns.length : 10"
            statusKey="1"
            :loading="loading"
            :maxResult="maxResult"
            :keyword="keyword"
            :isSearchAvailable="true"
            :defaultLimit="10"
            type="registration"
            ref="sortTable"
            path="TrainingContract"
            @refresh="refresh"
          />
        </div>
      </div>
    </div>
    <div
      :class="
        'col-lg-2 accordion order-lg-1 order-0 position-relative ' +
        (isFullScreen && windowWidth > 991 ? 'action__full-screen' : '')
      "
      id="accordionAction"
    >
      <button
        :class="'toggle_action ' + (isFullScreen && windowWidth > 991 ? '' : '-on')"
        @click="toggleAction"
        v-tooltip="{ title: $t('global.show_hide_actions') }"
      >
        <FontAwesomeIcon icon="fa-light fa-chevron-left" :class="'toggle_icon ' + (isFullScreen ? '' : 'rotate')" />
      </button>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingAction">
          <button
            :disabled="windowWidth > 991"
            :class="'accordion-button ' + (windowWidth < 991 ? 'collapsed' : '')"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseAction"
            aria-expanded="true"
            aria-controls="collapseAction"
          >
            {{ $t("actions") }}
          </button>
        </h2>
        <div
          id="collapseAction"
          :class="'accordion-collapse collapse ' + (windowWidth > 991 ? 'show' : '')"
          aria-labelledby="headingAction"
          data-bs-parent="#accordionAction"
        >
          <div class="accordion-body">
            <button
              class="btn btn-primary mb-2 me-2 btnStyle w-100 btnExport"
              type="button"
              @click="exportForm"
              v-access:[permissions]="accessManager().EDIT"
            >
              <FontAwesomeIcon class="me-2" icon="fa-light fa-plus" />
              {{
                $tc("global.export.title", 1, {
                  name: $tc("studea_manager.contract.title", 2).toLowerCase(),
                })
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import SortTableComponent from "@/components/table/sortTable/SortTableComponent.vue";
import FilterBlockComponent from "@/components/blocks/FilterBlockComponent.vue";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";
import { registrationManager } from "@/services/registration/registration-manager";
import { adminManager } from "@/services/admin/admin-manager";
import { formManager } from "@/services/form/form-manager";
import { accessManager } from "@/services/security/access-manager";
import { useMainStore } from "@/store/main/main";
import { useUserStore } from "@/store/user/user";

export default {
  name: "RegistrationsListView",
  components: {
    FilterBlockComponent,
    SortTableComponent,
    FontAwesomeIcon,
  },
  data() {
    return {
      isFullScreen: true,
      loading: false,
      listParams: [],
      datas: [],
      isSearchOpen: false,
      isFiltered: false,
      sessionStorageKey: "studea-registration-list",
      maxResult: 0,
      modalTitle: "",
      searchTitle: "",
      modalType: "",
      keyword: "",
      filtersLabels: ["group"],
      actions: [
        {
          translation: "registration.group_action.see_sheet",
          icon: "eye",
          type: "success",
          actionType: "router",
          action: "TrainingPreRegistration",
          cfaStyle: false,
          alias: "training",
          access: accessManager.EDIT,
          paramsIndexes: {
            registration: 9,
            group: 10,
          },
          params: {
            tab: 1,
          },
        },
      ],
      columns: [],
      filterModels: [],
      exportModels: [],
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapState(useUserStore, {
      permissions: (store) => store.permissions,
    }),
  },
  watch: {
    windowWidth() {
      this.updateWindowWidth();
    },
  },
  mounted() {
    this.init();
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  beforeRouteUpdate() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  methods: {
    accessManager() {
      return accessManager;
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },

    setKeyword() {
      if (window.sessionStorage.getItem(this.sessionStorageKey + "-keywords")) {
        this.keyword = window.sessionStorage.getItem(this.sessionStorageKey + "-keywords");
      }
      if (this.keyword) {
        this.listParams["keywords"] = this.keyword;
      }
    },

    refresh(params) {
      this.listParams = params;
      window.sessionStorage.setItem(this.sessionStorageKey + "-keywords", this.listParams.keywords);
      this.keyword = this.listParams.keywords;
      this.init();
    },

    search() {
      const params = formManager.processForm(this.filterModels, true);
      this.loading = true;
      if (this.$refs.sortTable) {
        this.$refs.sortTable.activePage = 1;
      }
      this.listParams["offset"] = 0;
      this.listParams["search"] = params;
      this.isFiltered = true;
      sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(params));
      this.getDatas();
      this.clearQueryParamsFromUrl();
    },

    submit() {
      if (this.modalType === "export") {
        const result = formManager.processForm(this.filterModels);
        adminManager.postExport("training", result).then((res) => {
          messengerMessageManager.processMessage(res);
        });
      }
    },

    init(reset = false) {
      this.setAppLoading(false);
      this.loading = true;
      this.setParams();
      this.getDatas();
      if (!reset) {
        this.getFilters();
      }
    },

    setParams() {
      if (!this.listParams || !Object.keys(this.listParams).length) {
        this.listParams = {
          search: "",
          sortByField: 0,
          sortOrder: "ASC",
          limit: 50,
          offset: 0,
        };
      }
    },

    setIsFilteredFromQuery(query) {
      if (query.registrationStep || query.group) {
        this.isFiltered = true;
      }
    },

    getDatas() {
      if (window.sessionStorage.getItem(this.sessionStorageKey)) {
        this.listParams["search"] = JSON.parse(window.sessionStorage.getItem(this.sessionStorageKey));
        this.isFiltered = true;
      }

      if (Object.keys(this.$route.query).length) {
        this.setIsFilteredFromQuery(this.$route.query);
        this.listParams["search"] = formManager.getQuery(this.$route.query);
      } else if (this.isFiltered) {
        this.listParams["search"] = formManager.getQuery(this.listParams["search"]);
      }

      this.setKeyword();
      registrationManager.list(this.listParams, "registration").then((data) => {
        this.columns = sortableTableManager.getEntriesColumns(data.columns, this.columns);
        if (this.columns && this.columns[3]) {
          this.columns[3].sortable = false;
        }
        this.actions[0].paramsIndexes.group = this.columns ? this.columns.length + 1 : 10;
        this.actions[0].paramsIndexes.registration = this.columns ? this.columns.length : 9;
        this.datas = data.data;
        this.maxResult = data.count;
        this.loading = false;
      });
    },

    getFilters() {
      this.filterModels = [];
      this.loading = true;
      this.searchTitle = this.$tc("global.search.title", 2, {
        name: this.$tc("studea_manager.registration.title", 2).toLowerCase(),
      });
      let query;
      if (window.sessionStorage.getItem(this.sessionStorageKey)) {
        query = { search: formManager.getQuery(JSON.parse(window.sessionStorage.getItem(this.sessionStorageKey))) };
      }

      if (Object.keys(this.$route.query).length) {
        this.setIsFilteredFromQuery(this.$route.query);
        query = { search: formManager.getQuery(this.$route.query) };
      }

      registrationManager.search("registration", false, query).then((data) => {
        this.filterModels = data;
        this.clearQueryParamsFromUrl();
      });
    },

    clearQueryParamsFromUrl() {
      this.$router.push({ name: this.$route.name });
    },

    resetSearch() {
      this.listParams = [];
      if (this.$refs.sortTable) {
        this.$refs.sortTable.activePage = 1;
      }
      this.datas = [];
      this.columns = [];
      this.isFiltered = false;
      window.sessionStorage.removeItem(this.sessionStorageKey);
      window.sessionStorage.removeItem(this.sessionStorageKey + "-keywords");
      this.keyword = "";
      this.clearQueryParamsFromUrl();
      this.init(true);
    },

    exportForm() {
      this.modalType = "export";
      this.modalTitle = this.$tc("global.export.title", 2, {
        name: this.$tc("admin.training.title", 2).toLowerCase(),
      });
      adminManager.exportForm("training").then((models) => {
        this.exportModels = models;
      });
    },

    toggleAction() {
      this.isFullScreen = !this.isFullScreen;
    },

    ...mapActions(useMainStore, ["setAppLoading"]),
  },
};
</script>

<style lang="scss" scoped>
.widget-heading {
  cursor: pointer;
  transition: all 300ms ease-in-out;

  &.-list {
    cursor: initial;
  }

  svg {
    width: 18px;
    height: 18px;
  }

  &.collapsed {
    padding-bottom: 0;
  }
}

.widget {
  padding-bottom: 20px;
}

.widget-content {
  padding-bottom: 0;
}

.accordion-button {
  padding: 20px;
}

.container-widget {
  @include up-to-lg {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
  }
  padding-right: 38px;
  transition: width ease-in-out 300ms;
}

.full-screen {
  padding-right: 38px;
  width: 100%;
}

.action__full-screen {
  transition: all ease-in-out 300ms;
}

.accordion-item {
  position: relative;
  z-index: 2;
}

.toggle_icon {
  transform: rotate(0deg);
  transition: all ease-in-out 300ms;

  &.rotate {
    transform: rotate(180deg);
  }
}

.toggle_action {
  position: absolute;
  display: block;
  z-index: 0;
  top: 0;
  left: -30px;
  padding: 2px 20px 2px 10px;
  border: 1px solid #e0e6ed;
  background-color: $green;
  box-shadow: 0 0 40px 0 rgba(94, 92, 154, 0.06);
  border-radius: 6px;
  color: $white;
  height: 67px;
  transition: background-color ease-in-out 300ms;

  &.-on {
    color: #212529;
    background-color: $white;
  }

  @include up-to-lg {
    display: none;
  }
}

.accordion {
  padding-left: 0;
}
</style>
